<template>
  <div id="register">
    <Title title="手机号注册" />
    <div class="form">
      <ul>
        <li>
          <input
            type="number"
            placeholder="请输入您的手机号码"
            v-model="phone"
          />
          <i class="close" v-if="phone !== ''" @click="phone = ''">×</i>
        </li>
        <li>
          <input type="number" placeholder="请输入验证码" v-model="code" />
          <span class="code" :class="sending" @click="send">{{ codeTxt }}</span>
        </li>
      </ul>
      <div class="agree">
        <div class="check">
          <mt-checklist v-model="value" :options="options"> </mt-checklist>
        </div>
        <div @click="check">
          提交验证平台将为您自动注册账号，代表您确认已阅读并同意
          <span>《注册服务协议》</span> 和 <span>《隐私协议》</span> 。
        </div>
      </div>
      <div class="btn">
        <mt-button size="large" type="primary" @click="register"
          >注册</mt-button
        >
        <p class="green">提示：注册成功后自动绑定微信</p>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/Title";
import { mapState } from "vuex";

export default {
  components: {
    Title,
  },
  data() {
    return {
      phone: "", //手机号
      code: "", //验证码
      value: [], //协议是否同意
      codeTxt: "获取验证码",
      sending: "",
      options: [
        {
          label: " ",
          value: "1",
        },
      ],
    };
  },
  mounted() {
    
  },
  methods: {
    //注册
    register() {
      if (this.phone === "") {
        this.$toast({
          message: "请输入手机号",
          duration: 1000,
        });
        return;
      }
      if (!this.regularPhone(this.phone)) {
        this.$toast({
          message: "请输入正确的手机号",
          duration: 1000,
        });
        return;
      }
      if (this.code === "") {
        this.$toast({
          message: "请输入验证码",
          duration: 1000,
        });
        return;
      }
      if (this.value.length == 0) {
        this.$toast({
          message: "请同意相关协议",
          duration: 1000,
        });
        return;
      }

      this.post(this.apis.register, {
        identifyingCode: this.code,
        mobile: this.phone,
        weixinId: this.openIdKey,
      })
        .then((response) => {
          this.$toast({
            message: response.data.retMsg,
            duration: 1000,
          });
          if (response.data.retCode == "SUCCESS") {
            setTimeout(() => {
              this.changeRouter("/baseInfo");
            }, 700);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 发送验证码
    send() {
      if (this.phone === "") {
        this.$toast({
          message: "请输入手机号",
          duration: 1000,
        });
        return;
      }
      if (!this.regularPhone(this.phone)) {
        this.$toast({
          message: "请输入正确的手机号",
          duration: 1000,
        });
        return;
      }

      if (this.codeTxt !== "获取验证码") return;
      let timer = null;
      let lastTime = 60;
      timer = setInterval(() => {
        lastTime--;
        this.codeTxt = `重新发送${lastTime}S`;
        this.sending = "sending";
        if (lastTime <= 0) {
          clearInterval(timer);
          this.codeTxt = `获取验证码`;
          this.sending = "";
        }
      }, 1000);
      this.getCode(this.phone);
    },
    //协议
    check() {
      this.value.length == 0 ? this.value.push("1") : (this.value = []);
    },
  },
   computed: {
    ...mapState(["openIdKey","userInfo"]),
  },
};
</script>

<style lang="less" scoped>
#register {
  background-color: #fff;
  padding: 0 70px;
  .form {
    li {
      margin-top: 10px;
      height: 104px;
      border-bottom: 1px solid #c5c5c5;
      display: flex;
      justify-content: space-between;
      align-items: center;
      input {
        border: none;
        height: 90px;
        width: 70%;
        outline: none;
        font-size: 30px;
      }
      .code {
        line-height: 90px;
        width: 28%;
        text-align: center;
        font-size: 30px;
        color: #1fbe6e;
        word-break: keep-all;
        &.sending {
          color: #c5c5c5;
        }
      }
      .close {
        font-style: normal;
        width: 32px;
        height: 32px;
        background-color: #8e8e93;
        font-size: 32px;
        color: #fff;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
      }
    }
    .agree {
      margin-top: 55px;
      display: flex;
      font-size: 24px;
      color: #ababab;
      line-height: 37px;
      span {
        color: #1fbe6e;
      }
      .check {
        width: 46px;
        height: 46px;
        position: relative;
        top: -5px;
        left: -10px;
      }
    }
    .mint-checkbox-label {
      font-size: 30px;
    }
    .btn {
      margin-top: 62px;
      .green {
        padding-top: 30px;
        text-align: center;
        font-size: 26px;
      }
    }
  }
}
</style>
